// src/core/alert/sweetAlertConfig.js
import Swal from 'sweetalert2'

// Reusable small popup styling
const swalSmall = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-success swal-confirm-button',
    cancelButton: 'btn btn-danger swal-cancel-button',
    popup: 'small-swal'
  },
  buttonsStyling: false
})

// ---------- Simple success/info/error helpers ----------
export const showSuccessAlert = (message) => {
  return Swal.fire({
    title: message || 'Added Successfully',
    icon: 'success',
    customClass: { popup: 'small-swal' }
  })
}

export const showSuccessResetAlert = (message) => {
  return Swal.fire({
    title: message || 'Password Reset Successfully',
    icon: 'success',
    customClass: { popup: 'small-swal' }
  })
}

export const showSuccess = (message) => {
  return Swal.fire({
    title: message || 'Added Successfully',
    icon: 'success',
    customClass: { popup: 'small-swal' }
  })
}

export const showSuccessUpdateAlert = (message) => {
  return Swal.fire({
    title: message || 'Updated Successfully',
    icon: 'success',
    customClass: { popup: 'small-swal' }
  })
}

export const showDeleteAlert = (message) => {
  return Swal.fire({
    title: message || 'Deleted Successfully',
    icon: 'success',
    customClass: { popup: 'small-swal' }
  })
}

export const showCancelAlert = () => {
  return Swal.fire({
    title: 'Canceled Successfully',
    icon: 'success',
    customClass: { popup: 'small-swal' }
  })
}

export const showUnmergeAlert = () => {
  return Swal.fire({
    title: 'Unmerged Successfully',
    icon: 'success',
    customClass: { popup: 'small-swal' }
  })
}

// ---------- Confirmation helpers ----------
export const showDeleteConfirmation2 = (text) => {
  return Swal.fire({
    title: 'Are you sure?',
    text: text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete',
    cancelButtonText: 'Cancel',
    reverseButtons: true,
    focusCancel: true,
    customClass: { popup: 'small-swal' }
  }).then(r => r.isConfirmed === true)
}

export const showDeleteConfirmation = (onConfirm) => {
  swalSmall.fire({
    title: 'Delete Confirmation',
    text: 'Do you really want to delete this item? This action cannot be reversed.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, cancel!',
    reverseButtons: true
  }).then(result => {
    if (result.isConfirmed) {
      onConfirm && onConfirm()
      swalSmall.fire({
        title: 'Deleted!',
        text: 'The item has been deleted successfully.',
        icon: 'success'
      })
    } else if (result.isDismissed && result.dismiss === Swal.DismissReason.cancel) {
      swalSmall.fire({
        title: 'Cancelled',
        text: 'Your item is safe and was not deleted.',
        icon: 'error'
      })
    }
  })
}

export const showCancelConfirmation = (onConfirm) => {
  swalSmall.fire({
    title: 'Cancel Confirmation',
    text: 'Do you really want to Cancel this item? This action cannot be reversed.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, Cancel it!',
    cancelButtonText: 'No, cancel!',
    reverseButtons: true
  }).then(result => {
    if (result.isConfirmed) {
      onConfirm && onConfirm()
      swalSmall.fire({
        title: 'Canceled!',
        text: 'The item has been Canceled successfully.',
        icon: 'success'
      })
    } else if (result.isDismissed && result.dismiss === Swal.DismissReason.cancel) {
      swalSmall.fire({
        title: 'Cancelled',
        text: 'Your item is safe and was not Canceled.',
        icon: 'error'
      })
    }
  })
}

export const showUnmergeConfirmation = (onConfirm) => {
  swalSmall.fire({
    title: 'Unmerge Confirmation',
    text: 'Do you really want to Unmerge this group? This action cannot be reversed.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, Unmerge it!',
    cancelButtonText: 'No, cancel!',
    reverseButtons: true
  }).then(result => {
    if (result.isConfirmed) {
      onConfirm && onConfirm()
      swalSmall.fire({
        title: 'Unmerged!',
        text: 'The group has been unmerged successfully.',
        icon: 'success'
      })
    } else if (result.isDismissed && result.dismiss === Swal.DismissReason.cancel) {
      swalSmall.fire({
        title: 'Cancelled',
        text: 'Your group is safe and was not unmerged.',
        icon: 'error'
      })
    }
  })
}

export const showConfirmSubmission = async (totalAmount) => {
  const result = await swalSmall.fire({
    title: 'Confirm Submission',
    text: `Total Amount calculated as Rs. ${Number(totalAmount).toLocaleString()}. Proceed with submission?`,
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Yes, submit!',
    cancelButtonText: 'No, cancel!',
    reverseButtons: true
  })
  return result.isConfirmed
}
export const showDepartmentConfirmSubmission = async () => {
  const result = await swalSmall.fire({
    title: 'Confirm Department Submission',
    text: 'Are you sure you want to submit this to the department?',
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Yes, submit',
    cancelButtonText: 'No, cancel',
    reverseButtons: true
  })

  return result.isConfirmed
}


// ---------- Error helpers (fixed icon bug) ----------
export const showItemExistsError = (message) => {
  return Swal.fire({
    icon: 'error',
    title: 'Oops...',
    text: message || 'This Item Already Exists.',
    customClass: { popup: 'small-swal' }
  })
}

export const showItemAlreadyUsed = (message) => {
  return Swal.fire({
    icon: 'error',
    title: 'Oops...',
    text: message || "This Item is already used, so it can't be deleted.",
    customClass: { popup: 'small-swal' }
  })
}

export const showError = (message) => {
  return Swal.fire({
    icon: 'error',
    title: 'Oops...',
    text: message,
    customClass: { popup: 'small-swal' }
  })
}

// ---------- One-time style injection (SSR-safe) ----------
;(function injectSwalStyleOnce() {
  if (typeof document === 'undefined') return
  const id = 'swal-small-style'
  if (document.getElementById(id)) return

  const style = document.createElement('style')
  style.id = id
  style.textContent = `
    .swal-cancel-button { margin-right: 10px; }
    .small-swal { width: 400px !important; padding: 1rem !important; font-size: 0.9rem !important; }
    .small-swal .swal2-title { font-size: 1.2rem !important; }
    .small-swal .swal2-html-container { font-size: 0.9rem !important; }
    .small-swal .swal2-icon { font-size: 1rem !important; }
    .small-swal .swal2-actions { font-size: 0.8rem !important; }
    .small-swal .btn { padding: 0.3rem 0.8rem !important; font-size: 0.8rem !important; }
  `
  document.head.appendChild(style)
})()
